export default {
  get(field: string): string {
    let value = '';
    if (field.length) {
      let matches = document.cookie.match('(^|;)\\s*' + decodeURIComponent(field) + '\\s*=\\s*([^;]+)');
      value = matches?.pop() || '';
    }
    return value;
  },
  set(field: string, value: string): void {
    if (field.length && value.length) {
      document.cookie = encodeURIComponent(field) + '=' + encodeURIComponent(value);
    }
  }
}
